exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\ninput[type='text'] {\n  margin-bottom: 0px;\n}\npre {\n  font-family: inherit;\n  white-space: pre-wrap;\n  word-break: break-word;\n  border: none;\n  background: transparent;\n}\n", ""]);

// exports
